module.exports = __webpack_public_path__ + "img/agrartech_palyazat_inzert_inaktiv.260f34ce.png";